import { render, staticRenderFns } from "./TaskCommentList.vue?vue&type=template&id=6dc2bec5&scoped=true&"
import script from "./TaskCommentList.vue?vue&type=script&lang=js&"
export * from "./TaskCommentList.vue?vue&type=script&lang=js&"
import style0 from "./TaskCommentList.vue?vue&type=style&index=0&id=6dc2bec5&scoped=true&lang=scss&"
import style1 from "./TaskCommentList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc2bec5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VCard,VDivider,VIcon,VList,VListItem,VListItemTitle,VMenu})
